var React = require('react');

function Rapyd (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"17","fill":"#212121","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.8094 16L17 27.9238V28L19.6049 28L20.9994 18.6087L22.8738 18.6083C23.217 18.6087 23.5313 18.609 23.8569 18.8048C24.178 18.9978 24.4363 19.3514 24.4363 19.9783C24.4363 20.6074 24.1854 21.0182 23.8716 21.2791C23.5563 21.5413 23.217 21.6739 22.9235 21.6739H20.9806L23.2349 28L26.0059 28L26.0013 27.9114L24.5105 23.5553C25.5947 23.0129 26.8854 21.8245 26.9928 19.6558C27.0635 18.2274 26.6061 17.3155 25.9997 16.7598C25.3963 16.2068 24.8439 16 24.147 16L24.1458 16H18.8094Z","fill":"white","key":1})]);
}

Rapyd.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Rapyd;

Rapyd.default = Rapyd;
